"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function REMOVE_RESULTS(state) {
    state.searchResults = [];
}
exports.REMOVE_RESULTS = REMOVE_RESULTS;
function RESET_STATE(state) {
    state.carolCampaign = {
        campaignEnd: '',
        campaignStart: '',
        campaignTeaserPricesStart: '',
        contentSections: [],
        contentSectionsHeadline: '',
        createdAt: '',
        description: '',
        descriptionHtml: '',
        headerImage: {
            file: '',
            uid: '',
        },
        headline: '',
        id: '',
        specialOffers: [],
        subHeadline: '',
        tariffInformationDescription: '',
        tariffInformationDescriptionHtml: '',
        tariffInformationHeadline: '',
        teaserImage: {
            file: '',
            uid: '',
        },
        updatedAt: '',
    };
    state.filter = {
        depGermany: false,
        flightIncluded: false,
        priceModel: state.filter.priceModel,
        region: 'NONE',
        travelDuration: 9999,
    };
    state.sortBy = {
        code: 'price',
        name: 'Sortieren nach Preis',
        shortName: 'Preis',
    };
    state.specialSortBy = {
        code: 'price',
        name: 'Sortieren nach Preis',
        shortName: 'Preis',
    };
    state.searchResults = [];
    state.specialResults = [];
    state.numberCruises = 0;
}
exports.RESET_STATE = RESET_STATE;
function SET_CAROL_CAMPAIGN(state, data) {
    state.carolCampaign = data;
}
exports.SET_CAROL_CAMPAIGN = SET_CAROL_CAMPAIGN;
function SET_FILTER_DEP_GERMANY(state, value) {
    state.filter.depGermany = value;
}
exports.SET_FILTER_DEP_GERMANY = SET_FILTER_DEP_GERMANY;
function SET_FILTER_FLIGHT_INCLUDED(state, value) {
    state.filter.flightIncluded = value;
}
exports.SET_FILTER_FLIGHT_INCLUDED = SET_FILTER_FLIGHT_INCLUDED;
function SET_FILTER_PRICEMODEL(state, value) {
    state.filter.priceModel = value;
}
exports.SET_FILTER_PRICEMODEL = SET_FILTER_PRICEMODEL;
function SET_FILTER_REGION(state, value) {
    state.filter.region = value;
}
exports.SET_FILTER_REGION = SET_FILTER_REGION;
function SET_FILTER_TRAVEL_DURATION(state, value) {
    state.filter.travelDuration = value;
}
exports.SET_FILTER_TRAVEL_DURATION = SET_FILTER_TRAVEL_DURATION;
function SET_NUMBER_CRUISES(state, value) {
    state.numberCruises = value;
}
exports.SET_NUMBER_CRUISES = SET_NUMBER_CRUISES;
function SET_REGIONS(state, regions) {
    state.availableRegions = lodash_1.concat(state.availableRegions, regions);
}
exports.SET_REGIONS = SET_REGIONS;
function SET_RESULTS(state, routes) {
    state.searchResults = routes;
}
exports.SET_RESULTS = SET_RESULTS;
function SET_SORTBY(state, data) {
    state.sortBy = data;
}
exports.SET_SORTBY = SET_SORTBY;
function SET_SPECIAL_RESULTS(state, params) {
    var special = {
        code: params.code,
        offers: params.offers,
    };
    state.specialResults.push(special);
}
exports.SET_SPECIAL_RESULTS = SET_SPECIAL_RESULTS;
function SET_SPECIAL_SORTBY(state, data) {
    state.specialSortBy = data;
}
exports.SET_SPECIAL_SORTBY = SET_SPECIAL_SORTBY;
//# sourceMappingURL=mutations.js.map